import { render, staticRenderFns } from "./PoiSearch.vue?vue&type=template&id=52f2538c&scoped=true&"
import script from "./PoiSearch.vue?vue&type=script&lang=js&"
export * from "./PoiSearch.vue?vue&type=script&lang=js&"
import style0 from "./PoiSearch.vue?vue&type=style&index=0&id=52f2538c&prod&scoped=true&lang=css&"
import style1 from "./PoiSearch.vue?vue&type=style&index=1&id=52f2538c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f2538c",
  null
  
)

export default component.exports